import React, { Fragment, useContext, useEffect, useState } from "react";
import { FaUserGear, FaXmark } from "react-icons/fa6";

import { toast } from "react-toastify";
import { postApi, putApi } from "../../services/api/globalApi";
import { Field, Form, Formik } from "formik";
import { context } from "../../context/context";

const { forwardRef, useRef, useImperativeHandle } = React;

const ChequeModal = forwardRef(({ categoryData, currentCategory, reGetData }, ref) => {

    const { showLogutModal} = useContext(context)


    const [visible, setVisible] = useState(false)

    console.log(categoryData)
    const showModal = () => {
        setVisible(!visible);
        // clearState()
    };

    useImperativeHandle(ref, () => ({
        showModal() {
            setVisible(!visible);
        }
    }));

    const addCategory = async (values, { resetForm }) => {

        const test = categoryData.filter((item) => item.name != values.name)

        const body = {
            cheque:
                [...test, values]
        }
        try {
            const response = await postApi({
                path: 'admin/profitLoansFormula/createOrUpdate',
                body: body
            });
            toast.success("تغییرات با موفقیت ثبت شد.", {
                position: "top-right",
                closeOnClick: true
            });
            showModal()
            reGetData()
            resetForm()
        } catch (error) {
            console.error(error);
            toast.error(error?.response?.data?.errors.message, {
                position: "top-right",
                closeOnClick: true
            });
            error?.response.status == 401 && showLogutModal();
        }
    }

    return (
        <Fragment>
            <div className={`fixed top-0 right-[50%] w-[300px] mr-[-150px] md:w-[700px] md:mr-[-350px] mt-[5%] overflow-hidden transition-all z-[1021] rounded-3xl bg-gray-100 dark:bg-gray-800 mx-auto opacity-0 invisible ${visible && 'mt-[10%] !visible opacity-100'}`} >
                <div className="w-full h-14 flex justify-between items-center px-4">
                    <p className="flex items-center gap-x-2 text-lg text-gray-800 dark:text-white">
                        <FaUserGear size={24} />
                        ویرایش دسته بندی {categoryData?.name || "-"}
                    </p>
                    <FaXmark onClick={showModal} size="24" className="text-red-500 transition-all cursor-pointer hover:scale-110" />
                </div>
                <div className="border-b-2 w-11/12 mx-auto"></div>

                <Formik
                    enableReinitialize={true}
                    initialValues={{
                        name: currentCategory?.name,
                        perMounth: currentCategory?.perMounth,
                        totalProfit: currentCategory?.totalProfit,
                    }}
                    // validationSchema={validate}
                    onSubmit={addCategory}

                >
                    {(formik) => (
                        <Form className="w-full">
                            <div className="w-full flex flex-col justify-center items-center px-6 pt-6 pb-0 text-gray-800 dark:text-white">
                                <div className="grid gap-6 mb-6 md:grid-cols-3">
                                    <div>
                                        <label for="name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">نام دسته بندی</label>
                                        <Field autocomplete="off" type="text" name="name" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                            placeholder="نام دسته بندی" />
                                        {formik.errors.name && formik.touched.name ? (
                                            <p className="text-sm my-4 text-red-500">{formik.errors.name}</p>
                                        ) : null}
                                    </div>
                                    <div>
                                        <label for="perMounth" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">سود ماهانه</label>
                                        <Field autocomplete="off" type="text" name="perMounth" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                            placeholder="سود ماهانه" />
                                        {formik.errors.perMounth && formik.touched.perMounth ? (
                                            <p className="text-sm my-4 text-red-500">{formik.errors.perMounth}</p>
                                        ) : null}
                                    </div>
                                    <div>
                                        <label for="totalProfit" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">سود نهایی</label>
                                        <Field autocomplete="off" type="text" name="totalProfit" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                            placeholder="سود نهایی" />
                                        {formik.errors.totalProfit && formik.touched.totalProfit ? (
                                            <p className="text-sm my-4 text-red-500">{formik.errors.totalProfit}</p>
                                        ) : null}
                                    </div>
                                </div>
                            </div>

                            <div className="flex gap-x-2 items-center justify-end w-full p-3 pt-0">
                                <button
                                    onClick={showModal}
                                    type="reset"
                                    className="inline-block transition-all rounded-3xl bg-blue-600 hover:bg-blue-700 px-8 pb-2 pt-2 text-md font-medium uppercase leading-normal text-white shadow-info-3 transition duration-150 ease-in-out hover:bg-info-accent-300 hover:shadow-info-2 focus:bg-info-accent-300 focus:shadow-info-2 focus:outline-none focus:ring-0 active:bg-info-600 active:shadow-info-2 motion-reduce:transition-none dark:shadow-black/30 dark:hover:shadow-dark-strong dark:focus:shadow-dark-strong dark:active:shadow-dark-strong">
                                    بازگشت
                                </button>
                                <button
                                    type="submit"
                                    className="inline-block transition-all rounded-3xl bg-green-600  hover:bg-green-700 px-14 pb-2 pt-2 text-md font-medium uppercase leading-normal text-white shadow-danger-3 transition duration-150 ease-in-out hover:bg-danger-accent-300 hover:shadow-danger-2 focus:bg-danger-accent-300 focus:shadow-danger-2 focus:outline-none focus:ring-0 active:bg-danger-600 active:shadow-danger-2 motion-reduce:transition-none dark:shadow-black/30 dark:hover:shadow-dark-strong dark:focus:shadow-dark-strong dark:active:shadow-dark-strong">
                                    تغییر
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
            <div onClick={showModal} className={`fixed top-0 right-0 w-full h-full bg-black/50 z-[1020] invisible opacity-0 ${visible && '!visible opacity-100'}`}></div>
        </Fragment>
    )
})
export default ChequeModal